import { Search, SentimentDissatisfied } from "@mui/icons-material";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Products.css";
import ProductCard from "./ProductCard";
import Cart from "./Cart";
import { generateCartItemsFrom } from "./Cart";

// Definition of Data Structures used
/**
 * @typedef {Object} Product - Data on product available to buy
 *
 * @property {string} name - The name or title of the product
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */

const Products = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [apiProductsData, setApiProductsData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [debounceTimeout, setDebounceTimeout] = useState(0);
  const [isloading, setIsloading] = useState(true);
  const username = localStorage.getItem("username");
  const [fetchCartData, setFetchCartData] = useState([]);
  const [wholeData, setWholeData] = useState([]);
  const [cartData, setCartData] = useState([]);
  const token = localStorage.getItem("token");
  // TODO: CRIO_TASK_MODULE_PRODUCTS - Fetch products data and store it
  /**
   * Make API call to get the products list and store it to display the products
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on all available products
   *
   * API endpoint - "GET /products"
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "name": "iPhone XR",
   *          "category": "Phones",
   *          "cost": 100,
   *          "rating": 4,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "v4sLtEcMpzabRyfx"
   *      },
   *      {
   *          "name": "Basketball",
   *          "category": "Sports",
   *          "cost": 100,
   *          "rating": 5,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "upLK9JbQ4rMhTwt4"
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 500
   * {
   *      "success": false,
   *      "message": "Something went wrong. Check the backend console for more details"
   * }
   */
  const performAPICall = async () => {
    try {
      let response = await axios.get(`${config.endpoint}/products`);
      setWholeData(response.data);
    } catch {
      enqueueSnackbar("Something went wrong", {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };
  // console.log("line no:89", wholeData, fetchCartData);

  useEffect(() => {
    if (token) {
      performAPICall();
      fetchCart(token);
    }
  }, []);

  useEffect(() => {
    setCartData(generateCartItemsFrom(fetchCartData, wholeData));
  }, [wholeData, fetchCartData]);

  useEffect(() => {
    debounceSearch(searchValue, debounceTimeout);
  }, [searchValue]);

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Implement search logic
  /**
   * Definition for search handler
   * This is the function that is called on adding new search keys
   *
   * @param {string} text
   *    Text user types in the search bar. To filter the displayed products based on this text.
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on filtered set of products
   *
   * API endpoint - "GET /products/search?value=<search-query>"
   *
   */
  const performSearch = async (text) => {
    let url = `${config.endpoint}/products/search?value=${text.toLowerCase()}`;
    if (!text) {
      url = `${config.endpoint}/products`;
    }
    try {
      let response = await axios.get(url);
      // console.log(response);
      setApiProductsData(response.data);
      setIsloading(false);
    } catch {
      setApiProductsData([]);
      setIsloading(false);
    }
  };

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Optimise API calls with debounce search implementation
  /**
   * Definition for debounce handler
   * With debounce, this is the function to be called whenever the user types text in the searchbar field
   *
   * @param {{ target: { value: string } }} event
   *    JS event object emitted from the search input field
   *
   * @param {NodeJS.Timeout} debounceTimeout
   *    Timer id set for the previous debounce call
   *
   */
  const debounceSearch = (event, debounceTimeout) => {
    if (!searchValue) {
      performSearch(event);
      return;
    }
    if (debounceTimeout !== 0) {
      clearTimeout(debounceTimeout);
    }

    let timeOut = setTimeout(() => performSearch(event), 500);
    setDebounceTimeout(timeOut);
  };



  

  const fetchCart = async (token) => {
    try {
      let response = await axios.get(`${config.endpoint}/cart`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      // console.log(response.data);
      setFetchCartData(generateCartItemsFrom(response.data, apiProductsData));
    } catch {
      enqueueSnackbar("Something went wrong", {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
    //    let response = await axios.post(
    //       `${config.endpoint}/cart`,
    //       {
    //         productId: "PmInA797xJhMIPti",
    //         qty: 1,
    //       },
    //       {
    //         headers: {
    //           Authorization: `Bearer ${token}`,
    //           'Content-Type': "application/json",
    //         },
    //       }
    //     );
    //     console.log(response.data)
  };

  // const removeCartItem = async (id) => {
  //   let newCartData = [...fetchCartData];
  //   let removeCartIndex;
  //   for (let i = 0; i < newCartData.length; i++) {
  //     if (newCartData[i].productId === id) {
  //       removeCartIndex = i;
  //     }
  //   }
  //   newCartData.splice(removeCartIndex, 1);
  //   setFetchCartData(newCartData);
  
  // };

  // const handleAdd = async (id, qty) => {
   
  //   let quantity = parseInt(qty) + 1;
       
  //    await addToCart(id,  quantity);
  // };

  // const handleDelete = async (id, qty) => {
  //   let quantity = parseInt(qty) - 1;
  //   // console.log(quantity);
  
  //     // quantity = quantity - 1;
  //   await addToCart(id, quantity);
  // };

  const isItemInCart = (items, productId) => {
    return items.findIndex((item) => item.productId === productId) !== -1;
  };

  const addToCart = async (
    token,
    items,
    products,
    productId,
    qty,
    check = { preventDuplicate: false }
  ) => {
    if (!token) {
      enqueueSnackbar("Login to add an item to the Cart", {
        variant: "warning",
      });
      return;
    }
    if (check.preventDuplicate && isItemInCart(items, productId)) {
      enqueueSnackbar(
        "Item already in Cart.Use the cart sidebar to update quantity or remove item",
        { variant: "warning" }
      );
      return;
    }

    try {
      const url = `${config.endpoint}/cart`;
      const response = await axios.post(
        url,
        { productId, qty },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const cartItems = generateCartItemsFrom(response.data, products);
      setCartData(cartItems);
    } catch (error) {
      if (error.response) {
        enqueueSnackbar(error.response.data.message, { variant: "error" });
        return null;
      } else {
        enqueueSnackbar(
          "Could not fetch products. Check that the backend is running, reachable and returns valid JSON",
          { variant: "error" }
        );
      }
    }
  };

  return (
    <div>
      <Header hasHiddenAuthButtons="productPage">
        <TextField
          className="search-desktop"
          size="small"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Search color="primary" />
              </InputAdornment>
            ),
          }}
          placeholder="Search for items/categories"
          name="search"
          value={searchValue}
          onChange={(e) => {
            setSearchValue(e.target.value);
          }}
        />
      </Header>

      {/* TODO: CRIO_TASK_MODULE_PRODUCTS - Display search bar in the header for Products page */}

      {/* Search view for mobiles */}
      <TextField
        className="search-mobile"
        size="small"
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
        value={searchValue}
        onChange={(e) => {
          setSearchValue(e.target.value);
        }}
      />

      {username ? (
        <Grid container spacing={0}>
          <Grid item sm={12} md={8}>
            <Grid container spacing={2}>
              <Grid item className="product-grid">
                <Box className="hero">
                  <p className="hero-heading">
                    India’s
                    <span className="hero-highlight">FASTEST DELIVERY</span>
                    to your door step
                  </p>
                </Box>
              </Grid>

              {isloading ? (
                <Box className="loading">
                  <CircularProgress />
                  <Box>Loading Products...</Box>
                </Box>
              ) : apiProductsData.length ? (
                apiProductsData.map((product) => (
                  <Grid item key={product._id} xs={6} md={3}>
                    <ProductCard
                      product={{ ...product }}
                      handleAddToCart={async () => {
                        await addToCart(
                          token,
                          cartData,
                          apiProductsData,
                          product._id,
                          1,
                          { preventDuplicate: true }
                        );
                      }}
                    />
                  </Grid>
                ))
              ) : (
                <Box className="loading">
                  <SentimentDissatisfied />
                  <Box>No products found</Box>
                </Box>
              )}
            </Grid>
          </Grid>
          <Grid item sm={12} md={4} style={{ backgroundColor: "#E9F5E1" }}>
          <Cart
              products={apiProductsData}
              items={cartData}
              handleQuantity={addToCart}
            />
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={2}>
          <Grid item className="product-grid">
            <Box className="hero">
              <p className="hero-heading">
                India’s <span className="hero-highlight">FASTEST DELIVERY</span>
                to your door step
              </p>
            </Box>
          </Grid>

          {isloading ? (
            <Box className="loading">
              <CircularProgress />
              <Box>Loading Products...</Box>
            </Box>
          ) : apiProductsData.length ? (
            apiProductsData.map((product) => (
              <Grid item key={product._id} xs={6} md={3}>
                <ProductCard
                  product={{ ...product }}
                  handleAddToCart={addToCart}
                />
              </Grid>
            ))
          ) : (
            <Box className="loading">
              <SentimentDissatisfied />
              <Box>No products found</Box>
            </Box>
          )}
        </Grid>
      )}

      <Footer />
    </div>
  );
};

export default Products;
